import { Badge } from "@its-engineering-and-development/ui-foundation/components";
import { POLICY_AUTOMATIC, POLICY_STATUS } from "@app/types/policy";
import type { PolicyAutomatic, PolicyStatus } from "@app/types/policy";

const STATUS_BADGE_CONFIG: Record<PolicyStatus, { color: "success" | "gray"; label: string }> = {
    [POLICY_STATUS.Active]: { color: "success", label: POLICY_STATUS.Active },
    [POLICY_STATUS.Deactivated]: { color: "gray", label: POLICY_STATUS.Deactivated },
};

const AUTOMATIC_BADGE_CONFIG: Record<PolicyAutomatic, { color: "success" | "gray"; label: string }> = {
    [POLICY_AUTOMATIC.Yes]: { color: "success", label: POLICY_AUTOMATIC.Yes },
    [POLICY_AUTOMATIC.No]: { color: "gray", label: POLICY_AUTOMATIC.No },
};

export function PolicyStatusBadge({ status }: { status: PolicyStatus }) {
    const { color, label } = STATUS_BADGE_CONFIG[status];

    return (
        <Badge type="pill-color" color={color} size="sm">
            {label}
        </Badge>
    );
}

export function PolicyAutomaticBadge({ value }: { value: PolicyAutomatic }) {
    const { color, label } = AUTOMATIC_BADGE_CONFIG[value];

    return (
        <Badge type="pill-color" color={color} size="sm">
            {label}
        </Badge>
    );
}

export function PolicyProtocolBadge({ label }: { label: string }) {
    return (
        <Badge type="pill-color" color="brand" size="sm">
            {label}
        </Badge>
    );
}
